// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__Rtsbh","empty":"ModalGraph_empty__1zA1l"};